import type { InitOptions } from 'i18next';
import i18n from 'i18next';
import BrowserLanguageDetector from 'i18next-browser-languagedetector';
import httpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { config } from 'src/config';
import { LogLevel } from 'src/shared/constants';
import { isBrowser, isDevelopment } from 'src/shared/helpers/environment';

const LANGUAGE_FALLBACK = 'en';
const NAMESPACE_APP = 'app';
const NAMESPACE_COMMON = 'common';
const SUPPORTED_LANGUAGES = ['en'];

const missingKeyHandler = (
  languages: readonly string[],
  namespace: string,
  key: string,
) =>
  isDevelopment() &&
  // eslint-disable-next-line no-console
  console.error(
    `🌐 Missing [${languages.join(',')}] translation: ${namespace}.${key}`,
  );

const options: InitOptions = {
  debug: config.LOG_LEVEL === LogLevel.SILLY,
  defaultNS: NAMESPACE_COMMON,
  fallbackLng: LANGUAGE_FALLBACK,
  fallbackNS: [NAMESPACE_APP, NAMESPACE_COMMON],
  interpolation: { escapeValue: false },
  lng: LANGUAGE_FALLBACK,
  load: 'languageOnly',
  missingKeyHandler,
  ns: [NAMESPACE_COMMON],
  react: { useSuspense: false },
  saveMissing: isDevelopment(),
  supportedLngs: SUPPORTED_LANGUAGES,
};

const browserOptions: Partial<InitOptions> = {
  ...options,
  backend: {
    loadPath: '/i18n/{{lng}}/{{ns}}.json',
    customHeaders: { 'X-Hover-For': config.APPLICATION_NAME },
  },
};

if (isBrowser()) {
  i18n.use(httpBackend).use(initReactI18next).use(BrowserLanguageDetector);
}

if (!i18n.isInitialized) {
  void i18n.init(browserOptions);
}

export { options as defaultOptions, i18n };
